import { createFileRoute } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { HomeSellFlow } from "@/components/home/HomeSellFlow";
import { latestAdsQueryOptions } from "@/lib/latest-ads";

export const Route = createFileRoute("/en/")({
  head: () => ({
    meta: [
      { title: "Sell your things – free listing in one minute | Sellavo" },
      {
        name: "description",
        content: "Sell second-hand items quickly. Take a photo, get a ready-made listing and price suggestion, and publish for free on Sellavo.",
      },
      { property: "og:title", content: "Sell your things – free listing in one minute | Sellavo" },
      {
        property: "og:description",
        content: "Take a photo, get a ready-made listing and price suggestion, and publish your second-hand item for free.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/en" }],
  }),
  loader: ({ context }: { context: { queryClient: QueryClient } }) => {
    void context.queryClient.prefetchQuery(latestAdsQueryOptions());
  },
  component: EnglishHomePage,
});

function EnglishHomePage() {
  return <HomeSellFlow />;
}